import React, { Suspense, useRef, useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Stage } from '@react-three/drei';
import Shoe from './Shoe';
import './style.css';

export default function Viewer() {
  const controlsRef = useRef();
  const modelRef = useRef();
  const canvasRef = useRef();
  const [showOverlay, setShowOverlay] = useState(false);
  const interactionTimeout = useRef(null);

  // Handler to reset interaction timer
  const resetInteractionTimer = () => {
    // Clear existing timer
    if (interactionTimeout.current) {
      clearTimeout(interactionTimeout.current);
    }
    // Hide overlay
    setShowOverlay(false);
    // Set new timer
    interactionTimeout.current = setTimeout(() => {
      setShowOverlay(true);
    }, 2000); // 10 seconds of inactivity
  };

  useEffect(() => {
    const canvasElement = canvasRef.current;
    // Add event listeners for user interaction
    canvasElement.addEventListener('mousemove', resetInteractionTimer);
    canvasElement.addEventListener('touchstart', resetInteractionTimer);
    canvasElement.addEventListener('touchmove', resetInteractionTimer);

    // Initialize interaction timer on mount
    resetInteractionTimer();

    return () => {
      // Clean up event listeners and timer
      canvasElement.removeEventListener('mousemove', resetInteractionTimer);
      canvasElement.removeEventListener('touchstart', resetInteractionTimer);
      canvasElement.removeEventListener('touchmove', resetInteractionTimer);
      clearTimeout(interactionTimeout.current);
    };
  }, []);

  useEffect(() => {
    if (controlsRef.current && modelRef.current) {
      controlsRef.current.fitToBox(modelRef.current, true);
    }
  }, []);

  return (
    <div className="viewer-container" ref={canvasRef}>
      <div className="canvas-container">
        {showOverlay && (
          <img src="Cursor-Gif_6.gif" alt="Inactivity Overlay" className="inactivity-overlay" />
        )}
        <Suspense fallback={<div>Loading...</div>}>
          <Canvas shadows camera={{ position: [0, 0, 50], fov: 20 }}>
            <ambientLight intensity={0.5} />
            <directionalLight position={[10, -20, 5]} intensity={0.7} castShadow />
            <directionalLight position={[0, 5, 5]} intensity={0.7} castShadow />
            <Stage environment="studio" intensity={0.75} adjustCamera={false}>
              <Shoe ref={modelRef} />
            </Stage>
            <OrbitControls
              ref={controlsRef}
              autoRotate
              enablePan={false}
              enableZoom={false}
              autoRotateSpeed={4}
              enableDamping
              dampingFactor={0.1}
              makeDefault
            />
          </Canvas>
        </Suspense>
      </div>

      <a href="https://calendly.com/vincent-119" target="_blank" rel="noopener noreferrer" className="viewer-demo-button">
        Book a Demo
      </a>
    </div>
  );
}
